module.exports = __webpack_public_path__ + "static/salon-7126ab45f9616c485ccdc2b0a8ab3402.jpg";